import { render, staticRenderFns } from "./AdvisorSwitch.vue?vue&type=template&id=20816312&"
import script from "./AdvisorSwitch.vue?vue&type=script&lang=ts&"
export * from "./AdvisorSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./AdvisorSwitch.vue?vue&type=style&index=0&id=20816312&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports